import $ from 'jquery';
import html from 'nanohtml';
import raw from 'nanohtml/raw';

import './style.scss';

export default class ProductInfoViewer {
  static defaults = {
    maxHeight: 600,
    adSlider: '.ad-slider',
  };

  constructor(elem, options = {}) {
    this.$elem = $(elem);
    this.$gridWrap = this.$elem.find('.grid-wrap');
    this.options = $.extend({}, this.constructor.defaults, options);
    this.on = this.$elem.on;
    this.trigger = this.$elem.trigger;
    this.$tiles = this.$elem.find('.product-tile');
    this.$slides = [];
    this.activeTile = null;
    this.heroImage = this.$elem.data('heroImage');
    this.$adSlider = $(this.options.adSlider);
    this.$infoView = this.$adSlider.find('.product-info-viewer');
    this.originalHeight = this.$adSlider.height();
    this.desktopMatcher = matchMedia('screen and (min-width: 1024px)');

    this.init();
  }

  desktopHandler = ({ matches }) => {
    if (matches) {
      console.debug('Desktop slider breakpoint handlers');
      this._unbindEvents();
      this._bindEvents();
    } else {
      console.debug('Mobile slider breakpoint handlers');
      this._unbindEvents();
      this._bindMobileEvents();
    }
  };

  handleTileClick = (evt) => {
    evt.preventDefault();

    const $tile = $(evt.currentTarget);

    this.renderTileContent($tile);
  };

  handleSlideClose = (evt) => {
    evt.preventDefault();

    const $slide = $(evt.currentTarget).closest('.product-slide');
    $slide.toggleClass('-active');
    this.$infoView.height(0);
  };

  openFallbackLink = (evt) => {
    evt.preventDefault();

    const $slide = $(evt.currentTarget);
    const url = $slide.data('fallbackLink');

    if (!url) return false;

    window.location.assign($slide.data('fallbackLink'));
  };

  init() {
    this._makeSlides();

    this.desktopMatcher.addListener(this.desktopHandler);
    this.desktopHandler(this.desktopMatcher);

    console.log('Initialize product info viewer: %O', this);
  }

  _makeSlides() {
    const slides = [];

    this.$tiles.each((_index, tile) => {
      const $tile = $(tile);
      const content = $tile.find('.product-tile__content').html();
      const title = $tile.find('.product-tile__title').text();
      const image = $tile.data('fullImage');
      const slide = html`
        <div class="product-slide">
          <img src="${image}" class="product-slide__image" alt="${title}" />
          <div class="product-slide__content">
            ${raw(content)}
          </div>
          <button class="product-slide__close">
            <span class="dashicons dashicons-arrow-down-alt2"></span>
          </button>
        </div>
      `;

      this.$infoView.append(slide);
      slides.push(slide);
      $tile.data('slide', $(slide));
    });

    this.$slides = $(slides);
  }

  _bindEvents() {
    console.debug('Bind product slider destktop click handlers');

    this.$elem.on('click', '.product-tile', this.handleTileClick);
    this.$adSlider.on('click', '.product-slide__close', this.handleSlideClose);
  }

  _bindMobileEvents() {
    console.log('bind product tile mobile click handler');
    this.$elem.on('click', '.product-tile', this.openFallbackLink);
  }

  _unbindEvents() {
    console.debug('unbind product tile interaction events');

    this.$elem
      .off('click', '.product-tile', this.handleTileClick)
      .off('click', '.product-tile', this.openFallbackLink);
    this.$adSlider.off('click', '.product-slide__close', this.handleSlideClose);
  }

  async renderTileContent($tile) {
    const $slide = $tile.data('slide');

    if ($slide.hasClass('-active')) return;

    this.$slides.removeClass('-active');
    this.$tiles.removeClass('-active');

    this.$infoView.height(Math.min($slide.height(), this.options.maxHeight));

    $tile.addClass('-active');

    await this.cssTransition($slide, () => {
      $slide.addClass('-active');
    });

    console.debug('Render tile content: %O', $tile.data());
  }

  cssTransition($el, mutate, options = {}) {
    const { timeout = 1000 } = options;

    return new Promise((resolve, reject) => {
      const rejectTimer = setTimeout(() => {
        $el.off('transitionend webkitTransitionEnd');
        reject($el);
      }, timeout);

      $el.one('transitionend webkitTransitionEnd', () => {
        console.debug('transitionend on %O', $el[0]);
        clearTimeout(rejectTimer);
        $el.off('transitionend webkitTransitionEnd');
        resolve($el);
      });

      mutate($el);
    });
  }
}

$.fn.productInfoViewer = function (options) {
  $(this).each((idx, elem) => {
    $(elem).data('productInfoViewer', new ProductInfoViewer(elem, options));
  });
};

$(function () {
  $('.home-product-tiles').productInfoViewer();
});
